import { useDispatch } from "react-redux";
import { useCallback } from "react";
import { openSideMenu } from "../../redux/ui/uiSlice";
import MiniExchangesMenu from "./mini-exchange-menu/MiniExchangesMenu";

function MiniExchangesButton({ title, className }) {
  const dispatch = useDispatch();

  const openMenu = useCallback(() => {
    dispatch(openSideMenu("mini-exchanges", "mini-exchanges"));
  }, []);

  return (
    <>
      <span className={className} onClick={openMenu}>
        {title || "Exchanges"}
      </span>

      <MiniExchangesMenu />
    </>
  );
}

export default MiniExchangesButton;
